import { combineReducers } from 'redux'

import * as t from './actionTypes'

const queue = (initState, setter, adder) => (state = initState, action) => {
  switch(action.type) {
    case setter:
      return action.payload
    case adder:
      return [...state, action.payload]
    default:
      return state
  }
}

const submissionQueue = queue([], t.SET_SUBMISSION_QUEUE, t.ADD_TO_SUBMISSION_QUEUE)

const queues = combineReducers({
  submissions: submissionQueue
})

export {queues as default}


// WEBPACK FOOTER //
// ./assets/interview/queues.js